<template>
    <div :class="['flex flex-nowrap w-full items-center gap-2 overflow-x-auto overflow-y-hidden py-2 px-1 bg-white dark:bg-dark-800', classAdd]">
        <!-- All button -->
        <button
            @click="setCurrentItem(null)"
            :class="[
                'whitespace-nowrap px-4 py-2 rounded-lg font-medium text-sm transition-all duration-200',
                activeItem === null
                    ? 'bg-primary text-white shadow-md shadow-primary/20'
                    : 'border border-primary bg-light text-primary hover:bg-gray-200 dark:bg-dark-700 dark:text-gray-300 dark:hover:bg-dark-900'
            ]"
        >
            {{ allLabel }}
        </button>

        <!-- Filter items -->
        <button
            v-for="item in items"
            :key="getItemId(item)"
            @click="setCurrentItem(getItemId(item))"
            :class="[
                'whitespace-nowrap px-4 py-2 rounded-lg font-medium text-sm transition-all duration-200',
                activeItem === getItemId(item)
                    ? 'bg-primary text-white shadow-md shadow-primary/20'
                    : 'border border-primary bg-light text-primary hover:bg-gray-200 dark:bg-dark-700 dark:text-gray-300 dark:hover:bg-dark-900'
            ]"
        >
            {{ getItemLabel(item) }}
        </button>
    </div>
</template>

<script>
export default {
    name: 'FilterLane',
    props: {
        items: {
            type: Array,
            required: true
        },
        classAdd: {
            type: String,
            default: ''
        },
        allLabel: {
            type: String,
            default: 'Semua'
        },
        idKey: {
            type: String,
            default: 'id'
        },
        labelKey: {
            type: String,
            default: 'name'
        }
    },
    data() {
        return {
            activeItem: null
        }
    },
    methods: {
        setCurrentItem(item) {
            this.activeItem = item;
            this.$emit('setCurrentItem', item);
        },
        getItemId(item) {
            return typeof item === 'object' ? item[this.idKey] : item;
        },
        getItemLabel(item) {
            return typeof item === 'object' ? item[this.labelKey] : item;
        }
    }
}
</script>

<style scoped>
.overflow-x-scroll::-webkit-scrollbar {
    height: 6px;
    width: 6px;
}

.overflow-x-scroll::-webkit-scrollbar-track {
    @apply bg-gray-100 rounded-full;
}

.overflow-x-scroll::-webkit-scrollbar-thumb {
    @apply bg-gray-400 rounded-full hover:bg-gray-500;
}
</style>
